define(
	'C3.ShoppingExtensions.NewsletterSignup.States.View',
	[
		'SCView', 
		'newsletter_states_dropdown.tpl',
		'Profile.Model',
		//'SC.Configuration',
		'Utils',
		//'Backbone.View'
		],
	function(
		SCViewComponent, 
		newsletter_states_dropdown_tpl,
		ProfileModel,
		//Configuration,
		Utils,
		//BackboneView
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function NewsletterStatesView(options) {
			SCView.call(this);
			this.options = options || {};
			this.template = newsletter_states_dropdown_tpl;		
			this.selectedState = options.selectedState;
			//console.log(options)
		}

		// Inherit parent instance methods.
		NewsletterStatesView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		NewsletterStatesView.prototype.constructor = NewsletterStatesView;

		NewsletterStatesView.prototype.getContext = function() {
			var country =
            this.options.selectedCountry && this.options.countries[this.options.selectedCountry];
	        var states = country && country.states;
	        var self = this;

	         var profile = ProfileModel.getInstance()
			,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'


	        var selectedStateName= ''

	        _.each(states, function(state) {
	           // state.isSelected = state.code === self.options.selectedState;
	        	if(state.name == self.selectedState){
            		selectedStateName = state.name
            	}
	        });

	       // console.log(selectedStateName)
	        
			return {
				isCountryAndStatePresent: !!(country && states),
	            // @property {String} manage
	            manage: this.options.manage || '',
	            // @property {Array<Object>} sates
	            states: states,
	            // @property {String} selectedState
	            selectedState: this.options.selectedState,
	            selectedStateName : selectedStateName,
	            hasDefaultState : selectedStateName ? true : false,
	            isLoggedIn : is_logged_in,
	           // showStateField : (selectedStateName || this.options.selectedState) ? true : false
			}
		}

		// Return the AMD constructor.
		return NewsletterStatesView;
	}
);
